import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="hero hero-bg-image" id="home">
      <div className="hero-overlay"></div>
      <div className="hero-container hero-text-overlay">
        <div className="hero-text">
          <h1>{t('hero_heading')}</h1>
          <p>{t('hero_subtitle')}</p>
          <div className="hero-cta-group">
            <Link to="/franchise" className="btn btn-primary">{t('hero_cta')}</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;